import { ChatCategory } from './model/chat-category.model';
import { ChatSummary } from './model/chat-summary.model';

export interface TeamschatSummaryState {
    chatCategories: ChatCategory[];
    chatSummary: ChatSummary[];
    filteredChatSummary: ChatSummary[];
    keyword: string;
    hasPendingData?: boolean;
}

export const defaultState = (): TeamschatSummaryState => ({
    chatCategories: [],
    chatSummary: [],
    filteredChatSummary: [],
    keyword: '',
});
